<template>
  <div>
    <div class="SouhuoH5Waitinghandle" v-if="list.length > 0 || !finished">
      <div class="item" v-for="(item, index) in list" :key="index">
        <span class="time">{{ item.CreateTime | fomatTime }}</span>
        <div class="card">
          <div class="title">待办事项提醒</div>
          <div class="desc">
            <div class="descItem">
              <div class="leftPart">处理事项：</div>
              <div class="rightPart" v-text="item.AdminMessage"></div>
            </div>
            <div class="descItem" v-if="item.PunishRemark">
              <div class="leftPart">处理状态：</div>
              <div class="rightPart alert">{{ item.PunishRemark }}</div>
            </div>
            <div class="descItem" v-if="item.PunishRemark">
              <div class="leftPart">当前状态：</div>
              <div class="rightPart">{{ currentStatus }}</div>
            </div>
          </div>
          <div class="contactCustomerService">
            <div
              class="contactBtn tapActive"
              @click="
                $router.push({ name: 'posterDetail', query: { isContact: 1 } })
              "
            >
              联系客服
            </div>
          </div>
        </div>
      </div>
      <segement-line
        v-if="finished"
        line-text="没有更多待办事项啦"
      ></segement-line>
      <segement-line v-if="!finished" line-text="正在加载" :is-load="true">
      </segement-line>
    </div>
    <un-has-violation
      v-else
      tipText="
        暂无待处理事项
      "
    >
    </un-has-violation>
  </div>
</template>

<script>
import moment from "moment";
import UnHasViolation from "./UnHasViolation.vue";
export default {
  name: "SouhuoH5Waitinghandle",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    limitInfo: {
      type: Object,
      default: () => {
        return null
      }
    },
    finished: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  components: {
    UnHasViolation,
  },
  data() {
    return {};
  },

  computed: {
    currentStatus() {
      let tempBuyLimitStr = '' // 限制购买文案
      let  tempTALimitStr = '' // 限制提现文案
      let tempEndStr = '' // 最终文案
      let {
            IsBuyLimit, // 是否限制购买
            IsTALimit, // 是否限制提现
            BuyLimitRemoveDate, // 恢复购买日期
            TALimitRemoveDate, // 恢复提现日期
            TALimitRemainDayNums, // 提现剩余限制天数
            BuyLimitRemainDayNums, // 购买剩余限制天数
          } = this.limitInfo;
      if (!IsTALimit && !IsBuyLimit) {
        // 若用户未被限制提现&未被限制购买，则展现为：限制已解除
        tempEndStr = '限制已解除'
      }

      if (IsBuyLimit) {
        // 若用户仅被限制购买，根据限制期限展现为：
        if (BuyLimitRemainDayNums) {
          // 若限制期限为具体天数，则展现为：限制购买至【限制购买解除日期】
          tempBuyLimitStr = `限制购买至` + moment(BuyLimitRemoveDate).format("YYYY-MM-DD HH:mm")
        } else {
          // 若限制期限为无限期，则展现为：限制购买中
          tempBuyLimitStr = '限制购买中'
        }
      }

      if (IsTALimit) {
        // 若用户仅被限制提现，根据限制期限展现为
        if (TALimitRemainDayNums) {
          // 若限制期限为具体天数，则展现为：限制提现至【限制提现解除日期】
          tempTALimitStr = `限制提现至` + moment(TALimitRemoveDate).format("YYYY-MM-DD HH:mm")
        } else {
          // 若限制期限为无限期，则展现为：限制提现中
          tempTALimitStr = '限制提现中'
        }
      }
      
      if (IsTALimit && IsBuyLimit) {
        // 若用户同时限制提现&限制购买，则优先展现限制购买文案，用“ ; ”分隔后展现限制提现文案
        tempEndStr = `${tempBuyLimitStr};${tempTALimitStr}`
      } else {
        if (IsBuyLimit) {
          tempEndStr = tempBuyLimitStr
        }
        if (IsTALimit) {
          tempEndStr = tempTALimitStr
        }
      }
      return tempEndStr
    }
  },

  mounted() {},

  methods: {},
  filters: {
    fomatTime(val) {
      if (val) {
        return moment(val).format("YYYY-MM-DD HH:mm");
      }
      return "----";
    },
  },
};
</script>

<style lang="scss" scoped>
.SouhuoH5Waitinghandle {
  background-color: transparent;
  width: 100%;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    margin-top: 20px;
    .time {
      height: 20px;
      line-height: 20px;
      background-color: #dddddd;
      color: #fff;
      padding: 0 12px;
      border-radius: 10px;
      margin-bottom: 15px;
      font-size: 12px;
    }
    .card {
      width: 100%;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 8px;
      padding: 15px 15px 0;
      .title {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 1em;
      }
      .desc {
        margin: 15px 0 18px;
        font-size: 14px;
        line-height: 1.5em;
        .descItem {
          display: flex;
          margin-bottom: 13px;
          &:last-child {
            margin-bottom: 0;
          }
          .leftPart {
            min-width: 74px;
            flex-shrink: 0;
            color: #919191;
          }
          .rightPart {
            &.alert {
              color: #ff0000;
            }
          }
        }
      }
      .contactCustomerService {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        height: 46px;
        border-top: 1px solid #dddddd;
        .contactBtn {
          display: flex;
          align-items: center;
          justify-content: space-around;
          height: 30px;
          border-radius: 15px;
          font-size: 14px;
          border: 1px solid rgba(102, 102, 102, 100);
          padding: 0 12px;
        }
      }
    }
  }
}
</style>